<div class="two-way-slider">
    <div class="row">
        <!-- detail -->
        <div class="col-sm-6 left" [ngClass]="(versi == '1')?'order-1':'mt-sm-0 mt-4 order-2'">
            <div class="detail">
                <div class="border-bot"
                     [ngClass]="(versi == '1')?'title-ver1':'title-ver2'">
                    <p class="cat text-uppercase"> {{ dataTwoSlider?.parent.title }} </p>
                </div>
                <h6 class="sub-title my-3">{{ curData?.title }}</h6>
                <div class="sum" [innerHTML]="curDataDesc"></div>
                 <!-- link -->
                <div class="link mt-md-3 mt-2">
                     <!-- versi 1 -->
                    <a routerLink="/about-us/{{curData?.link}}" 
                       class="link-more"
                       *ngIf="versi == '1'">
                        {{ isLang?.learnMore }} 
                        <span class="pl-1 icon">
                            <i class="icon ion-ios-arrow-round-forward"></i>
                        </span>
                    </a>
                     <!-- versi 2 -->
                    <a routerLink="/our-products/{{curData?.link}}" 
                       class="link-more"
                       *ngIf="versi == '2'">
                       {{ isLang?.learnMore }} 
                       <span class="pl-1 icon">
                            <i class="icon ion-ios-arrow-round-forward"></i>
                        </span>
                    </a>
                </div>
            </div>
            <div class="prev-next d-lg-block d-none mt-3 text-right">
                <span class="circle mr-2" 
                        (click)="prev()">
                        <i class="icon ion-ios-arrow-back"></i>
                </span>
                <span class="circle"
                        (click)="next()">
                       <i class="icon ion-ios-arrow-forward"></i>
                </span>
            </div>
        </div>
        <!-- slider image -->
        <div class="col-sm-6 right" [ngClass]="(versi == '1')?'order-2  mt-sm-0 mt-3':'order-1'">
            <ngx-slick-carousel class="carousel" 
                                #slickModal="slick-carousel" 
                                [config]="slideConfig" 
                                (afterChange)="afterChange($event)">
                <div ngxSlickItem *ngFor="let data of dataTwoSlider?.content" class="slide">
                    <div class="thumbnail">
                        <img class="w-100" 
                            [src]="apiAsset + data.picture" 
                            [alt]=""
                            [ngClass]="(versi == '1')?'ver-1':'ver-2'">
                        <div class="prev-next d-lg-none d-flex">
                            <span class="circle mr-2" 
                                    (click)="prev()">
                                    <i class="icon ion-ios-arrow-back"></i>
                            </span>
                            <span class="circle"
                                    (click)="next()">
                                    <i class="icon ion-ios-arrow-forward"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </ngx-slick-carousel>
        </div>
    </div>
</div>
